import fetch from '@/utils/fetch';

const model = {
  state: {
    countMap: {
      drop_coupon: 0,
      lucky_draw: 0,
      new_welfare: 0,
      task_center: 0,
    },
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { marketingManage }, getState }) => ({
    async getMarketingManage() {
      fetch('/saasmerchant/web/queryCount').then((data2) => {
        const { countMap } = getState().marketingManage;
        marketingManage.setState({
          countMap: {
            ...countMap,
            new_welfare: data2?.activityConfigNum,
            task_center: data2?.marketJobNum,
          },
        });
      });
    },
  }),
};

export default model;
